(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cold-extraction-process"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.cold-extraction__detail-trigger');
    document.querySelectorAll('.cold-extraction__step[data-detail-open]').forEach((step) => {
      if (!trigger || step !== trigger.closest('.cold-extraction__step')) {
        step.removeAttribute('data-detail-open');
        step.querySelector('.cold-extraction__detail-trigger')?.setAttribute('aria-expanded', 'false');
      }
    });
    if (!trigger) return;
    const step = trigger.closest('.cold-extraction__step');
    const willOpen = !step.hasAttribute('data-detail-open');
    step.toggleAttribute('data-detail-open', willOpen);
    trigger.setAttribute('aria-expanded', String(willOpen));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cold-extraction__step[data-detail-open]').forEach((step) => {
      step.removeAttribute('data-detail-open');
      const trigger = step.querySelector('.cold-extraction__detail-trigger');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-information"] && !Shopify.designMode) return;
  try {
    
function initializeFrgPressMarquee() {
  const tracks = document.querySelectorAll(
    '[id$="__recognition_strip_press"] .section-content-wrapper > .group-block > .group-block-content > .group-block > .group-block-content'
  );

  tracks.forEach((track) => {
    if (track.dataset.frgMarqueeReady === 'true') return;

    const items = Array.from(track.children);
    if (items.length < 2) return;

    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.classList.add('frg-marquee-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      track.appendChild(clone);
    });

    track.dataset.frgMarqueeReady = 'true';
  });
}

function initializeFrgKronkArrow() {
  const notes = document.querySelectorAll(
    '[id$="__section_MXBcdT"] .section-content-wrapper > .group-block:last-child .text-block p'
  );

  notes.forEach((note) => {
    note.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('↙')) {
        node.textContent = node.textContent.replace('↙', '');
      }
    });

    Array.from(note.children).forEach((element) => {
      if (element.tagName === 'BR') element.remove();
    });

    note.classList.add('frg-kronk-note');
  });
}

initializeFrgPressMarquee();
initializeFrgKronkArrow();
document.addEventListener('shopify:section:load', initializeFrgPressMarquee);
document.addEventListener('shopify:section:load', initializeFrgKronkArrow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frg-olio-product-rail"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('frg-olio-rail')) {
    customElements.define('frg-olio-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rail-track]');
        this.querySelector('[data-rail-prev]')?.addEventListener('click', () => this.move(-1));
        this.querySelector('[data-rail-next]')?.addEventListener('click', () => this.move(1));
      }
      move(direction) {
        const card = this.track.querySelector('.frg-olio-rail__card');
        if (!card) return;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 16), behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frg-product-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  const initializeFrgStickyBuy = (bar) => {
    if (bar.dataset.frgStickyInitialized === 'true') return;
    bar.dataset.frgStickyInitialized = 'true';

    if (bar.dataset.revealAfterMainBuy !== 'true') {
      bar.classList.add('frg-sticky-buy--visible');
      bar.removeAttribute('aria-hidden');
      return;
    }

    const pageRoot = document.querySelector('main') || document;
    const purchaseControls = [...pageRoot.querySelectorAll('product-form-component, form[action*="/cart/add"]')].find((element) => {
      if (element.closest('.frg-sticky-buy')) return false;
      return element.querySelector('button[type="submit"], input[type="submit"]') !== null;
    });

    let frame;
    const updateVisibility = () => {
      frame = undefined;
      const passedPurchaseControls = purchaseControls
        ? purchaseControls.getBoundingClientRect().bottom <= 0
        : window.scrollY > 240;
      const visible = window.scrollY > 24 && passedPurchaseControls;
      bar.classList.toggle('frg-sticky-buy--visible', visible);
      bar.toggleAttribute('inert', !visible);
      if (visible) {
        bar.removeAttribute('aria-hidden');
      } else {
        bar.setAttribute('aria-hidden', 'true');
      }
    };

    const requestUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(updateVisibility);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    updateVisibility();
  };

  const initializeFrgStickyBars = (root = document) => {
    root.querySelectorAll('[data-frg-sticky-buy]').forEach(initializeFrgStickyBuy);
  };

  initializeFrgStickyBars();
  document.addEventListener('shopify:section:load', (event) => initializeFrgStickyBars(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  function initializeFrgCpooPressMarquee() {
    const tracks = document.querySelectorAll(
      '[id$="__recognition_strip_cpoo"] .section-content-wrapper > .group-block > .group-block-content > .group-block > .group-block-content'
    );

    tracks.forEach((track) => {
      if (track.dataset.frgCpooMarqueeReady === 'true') return;

      const items = Array.from(track.children);
      if (items.length < 2) return;

      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.classList.add('frg-cpoo-marquee-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        track.appendChild(clone);
      });

      track.dataset.frgCpooMarqueeReady = 'true';
    });
  }

  initializeFrgCpooPressMarquee();
  document.addEventListener('shopify:section:load', initializeFrgCpooPressMarquee);

  } catch(e) { console.error(e); }
})();
})();
